import React from 'react';
import { MessageBlock, Paragraph } from 'elmo-elements';

type OwnProps = {};

type StateProps = {};

type DispatchProps = {};

type Props = OwnProps & StateProps & DispatchProps;

const EmptyMessageComponent = () => (
  <MessageBlock>
    <MessageBlock.Header>
      There are no requests
    </MessageBlock.Header>
  </MessageBlock>
);

export const EmptyMessage = EmptyMessageComponent;
